class CountdownBar extends HTMLElement {
  constructor() {
    super();

    // Parse start and end time from attributes
    this.startTime = new Date(this.dataset.startTime.replace(" ", "T"));
    this.endTime = new Date(this.dataset.endTime.replace(" ", "T"));

    this.timerInterval = null;
  }

  connectedCallback() {
    this.startCountdown();
  }

  startCountdown() {
    this.updateCountdown(); // run once immediately

    this.timerInterval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  updateCountdown() {
    const now = new Date();

    // If before start, show full duration
    let diff =
      now < this.startTime ? this.endTime - this.startTime : this.endTime - now;

    if (diff <= 0) {
      clearInterval(this.timerInterval);
      this.remove();
      return;
    }

    // Convert diff (ms) to time
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const mins = Math.floor((diff / (1000 * 60)) % 60);
    const secs = Math.floor((diff / 1000) % 60);

    // Update DOM spans inside component
    this.querySelector(".Days .count-down-bar-item-number").innerText = days
      .toString()
      .padStart(2, "0");
    this.querySelector(".Hours .count-down-bar-item-number").innerText = hours
      .toString()
      .padStart(2, "0");
    this.querySelector(".Mins .count-down-bar-item-number").innerText = mins
      .toString()
      .padStart(2, "0");
    this.querySelector(".Secs .count-down-bar-item-number").innerText = secs
      .toString()
      .padStart(2, "0");
  }

  disconnectedCallback() {
    clearInterval(this.timerInterval);
  }
}

// Register the element
customElements.define("countdown-bar", CountdownBar);
